// URL prefix helper.
// base.html が window.V2_URL_PREFIX を {{u ""}} で事前注入する。
// Phase 5 以降は "" (root) で no-op。Phase 4 以前は "/v2" だった。
//
// 使い方: fetch(u("/upload")) → root では "/upload", 副パスマウント時は "<prefix>/upload"

declare global {
  interface Window {
    V2_URL_PREFIX?: string;
  }
}

export function u(path: string): string {
  const prefix = (typeof window !== "undefined" && window.V2_URL_PREFIX) || "";
  if (!prefix) return path;
  if (!path.startsWith("/")) path = "/" + path;
  return prefix + path;
}
